import MailTemplate from "../../../../domain/mail/template/MailTemplate";
import {
  ACTION_TYPE,
  MailTemplateAction,
  SetMailTemplateAction,
  SetMailTemplateContentAction,
  SetMailTemplateNameAction,
  SetMailTemplateSubjectAction
}                   from "./MailTemplateAction";

const reduceMailTemplate = (action: SetMailTemplateAction): MailTemplate => action.mailTemplate;
const reduceMailTemplateName = (state: MailTemplate, action: SetMailTemplateNameAction): MailTemplate => new MailTemplate(state.id, action.mailTemplateName, state.subject, state.content, state.trail);
const reduceMailTemplateSubject = (state: MailTemplate, action: SetMailTemplateSubjectAction): MailTemplate => new MailTemplate(state.id, state.name, action.mailTemplateSubject, state.content, state.trail);
const reduceMailTemplateContent = (state: MailTemplate, action: SetMailTemplateContentAction): MailTemplate => new MailTemplate(state.id, state.name, state.subject, action.mailTemplateContent, state.trail);

const mailTemplateReducer = (state: MailTemplate = new MailTemplate(), action: MailTemplateAction): MailTemplate => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_MAIL_TEMPLATE:
      return reduceMailTemplate(action as SetMailTemplateAction);
    case ACTION_TYPE.SET_MAIL_TEMPLATE_NAME:
      return reduceMailTemplateName(state, action as SetMailTemplateNameAction);
    case ACTION_TYPE.SET_MAIL_TEMPLATE_SUBJECT:
      return reduceMailTemplateSubject(state, action as SetMailTemplateSubjectAction);
    case ACTION_TYPE.SET_MAIL_TEMPLATE_CONTENT:
      return reduceMailTemplateContent(state, action as SetMailTemplateContentAction);
  }
};

export default mailTemplateReducer;
